import {formatPrice} from '../common';
import {formatCurrency} from '../common';

(function ($) {
    "use strict"
    window.$ = window.jQuery = $



    window.updateAllDaysTotal = function (){
        let $totalBlock = $(document).find('#all-days-total-block');
        if ($totalBlock.length){
            $.ajax({
                method: 'GET',
                url: window.location.href,
                data: {
                    'AJAX_CALL':'Y',
                    'AJAX':'Y',
                },
                cache: false,
                success: function (data) {
                    $totalBlock.html(data);
                },
                error: function (data) {
                    console.log(data);
                }
            });
        }

    };

    // BITRIX
    window.BasketPoolQuantity = function () {
        this.processing = false;
        this.poolQuantity = {};
        this.updateTimer = null;
        this.currentQuantity = {};
        this.lastStableQuantities = {};

        this.updateQuantity();
    };

    BasketPoolQuantity.prototype.updateQuantity = function () {
        var items = $('#basket_items').find('.cook');
        if (!!items && items.length > 0) {
            for (var i = 0; i < items.length; i++) {
                var itemId = items[i].id;
                this.currentQuantity[itemId] = BX('QUANTITY_' + itemId).value;
            }
        }

        this.lastStableQuantities = BX.clone(this.currentQuantity, true);
    };

    BasketPoolQuantity.prototype.changeQuantity = function (itemId) {
        var quantity = BX('QUANTITY_' + itemId).value;
        var isPoolEmpty = this.isPoolEmpty();

        if (this.currentQuantity[itemId] && this.currentQuantity[itemId] != quantity) {
            this.poolQuantity[itemId] = this.currentQuantity[itemId] = quantity;
        }

        if (!isPoolEmpty) {
            this.enableTimer(true);
        } else {
            this.trySendPool();
        }
    };

    BasketPoolQuantity.prototype.trySendPool = function () {
        if (!this.isPoolEmpty() && !this.isProcessing()) {
            this.enableTimer(false);
            recalcBasketAjax({});
        }
    };

    BasketPoolQuantity.prototype.isPoolEmpty = function () {
        return (Object.keys(this.poolQuantity).length == 0);
    };

    BasketPoolQuantity.prototype.clearPool = function () {
        this.poolQuantity = {};
    };

    BasketPoolQuantity.prototype.isProcessing = function () {
        return (this.processing === true);
    };

    BasketPoolQuantity.prototype.setProcessing = function (value) {
        this.processing = (value === true);
    };

    BasketPoolQuantity.prototype.enableTimer = function (value) {
        clearTimeout(this.updateTimer);
        if (value === false)
            return;

        this.updateTimer = setTimeout(function () {
            basketPoolQuantity.trySendPool();
        }, 1500);
    };

    window.deleteAllProducts = function (day = false) {
        var data = new FormData();
        data.append('action', 'delete_all');
        data.append('day', day);
        $.ajax({
            method: 'POST',
            url: '/ajax/basketItem.php',
            data: data,
            cache: false,
            contentType: false,
            processData: false,
            dataType: 'json',
            success: function (result) {
                if (result.success) {
                    $.ajax({
                        url: '/personal/cart/',
                        success: function (res) {
                            $('.full_basket').html($(res).find('.full_basket').html());
                            initMonthSlider();
                            $('.js-basket-menu-day[data-id="' + dayId + '"]').trigger('click');
                        }
                    });

                    $.ajax({
                        url: '/',
                        success: function (result) {
                            $('.modalCards').html($(result).find('.modalCards').html())
                        }
                    });
                }
            }
        })
    }

    function recalcBasketAjax(params) {
        if (window.basketPoolQuantity.isProcessing()) {
            return false;
        }

        var property_values = {},
            action_var = BX('action_var').value,
            items = $('#basket_items').find('.cook'),
            delayedItems = BX('delayed_items'),
            postData,
            i;

        postData = {
            'sessid': BX.message('bitrix_sessid'),
            'site_id': BX.message('SITE_ID'),
            'props': property_values,
            'action_var': action_var,
            'select_props': BX('column_headers').value,
            'offers_props': BX('offers_props').value,
            'quantity_float': BX('quantity_float').value,
            'price_vat_show_value': BX('price_vat_show_value').value,
            'hide_coupon': BX('hide_coupon').value,
            'use_prepayment': BX('use_prepayment').value
        };
        postData[action_var] = 'recalculate';
        if (!!params && typeof params === 'object') {
            for (i in params) {
                if (params.hasOwnProperty(i))
                    postData[i] = params[i];
            }
        }
        if (!!items && items.length > 0) {
            for (i = 0; items.length > i; i++) {
                if (BX('QUANTITY_' + items[i].id) !== null) {

                    if (BX('QUANTITY_' + items[i].id).value != "0") {
                        postData['QUANTITY_' + items[i].id] = BX('QUANTITY_' + items[i].id).value;
                    } else {
                        postData['DELETE_' + items[i].id] = 'Y';
                        $(".cook[id=" + items[i].id + "]").remove();
                    }


                    //postData['QUANTITY_' + items[i].id] = BX('QUANTITY_' + items[i].id).value;
                }
            }

        }

        if (!!delayedItems && delayedItems.children.length > 0) {
            for (i = 1; delayedItems.children.length > i; i++)
                postData['DELAY_' + delayedItems.children[i].id] = 'Y';
        }

        window.basketPoolQuantity.setProcessing(true);
        window.basketPoolQuantity.clearPool();

        BX.ajax({
            url: '/bitrix/components/bitrix/sale.basket.basket/ajax.php',
            method: 'POST',
            data: postData,
            dataType: 'json',
            onsuccess: function (result) {
                // BX.closeWait();
                window.basketPoolQuantity.setProcessing(false);

                if (params.coupon) {
                    //hello, gifts!
                    if (!!result && !!result.BASKET_DATA && !!result.BASKET_DATA.NEED_TO_RELOAD_FOR_GETTING_GIFTS) {
                        BX.reload();
                    }
                }

                if (window.basketPoolQuantity.isPoolEmpty()) {
                    updateBasketTable(null, result);
                    window.basketPoolQuantity.updateQuantity();
                } else {
                    window.basketPoolQuantity.enableTimer(true);
                }
                reloadBasket(false);
            }
        });
    }

    // check if quantity is valid
    // and update values of both controls (text input field for PC and mobile quantity select) simultaneously
    function updateQuantity(controlId, basketId, ratio, bUseFloatQuantity) {

        var oldVal = BX(controlId).defaultValue,
            newVal = parseFloat(BX(controlId).value) || 0,
            bIsCorrectQuantityForRatio = false,
            autoCalculate = ((BX("auto_calculation") && BX("auto_calculation").value == "Y") || !BX("auto_calculation"));


        if (ratio === 0 || ratio == 1) {
            bIsCorrectQuantityForRatio = true;
        } else {

            var newValInt = newVal * 10000,
                ratioInt = ratio * 10000,
                reminder = newValInt % ratioInt,
                newValRound = parseInt(newVal);

            if (reminder === 0) {
                bIsCorrectQuantityForRatio = true;
            }
        }

        var bIsQuantityFloat = false;

        if (parseInt(newVal) != parseFloat(newVal)) {
            bIsQuantityFloat = true;
        }

        newVal = (bUseFloatQuantity === false && bIsQuantityFloat === false) ? parseInt(newVal) : parseFloat(newVal).toFixed(4);
        newVal = correctQuantity(newVal);


        if (bIsCorrectQuantityForRatio) {
            BX(controlId).defaultValue = newVal;

            BX("QUANTITY_INPUT_" + basketId).value = newVal;

            // set hidden real quantity value (will be used in actual calculation)
            BX("QUANTITY_" + basketId).value = newVal;
            $("#QUANTITY_" + basketId).parent().find('.sum__number').text(newVal);

            if (autoCalculate) {
                window.basketPoolQuantity.changeQuantity(basketId);
            }
        } else {
            newVal = getCorrectRatioQuantity(newVal, ratio, bUseFloatQuantity);
            newVal = correctQuantity(newVal);

            if (newVal != oldVal) {
                BX("QUANTITY_INPUT_" + basketId).value = newVal;
                BX("QUANTITY_" + basketId).value = newVal;
                $("#QUANTITY_" + basketId).parent().find('.sum__number').text(newVal);
                if (autoCalculate) {
                    window.basketPoolQuantity.changeQuantity(basketId);
                }
            } else {
                BX(controlId).value = oldVal;
            }
        }
    }


    window.getCorrectRatioQuantity = function (quantity, ratio, bUseFloatQuantity) {
        var newValInt = quantity * 10000,
            ratioInt = ratio * 10000,
            reminder = (quantity / ratio - ((quantity / ratio).toFixed(0))).toFixed(6),
            result = quantity,
            bIsQuantityFloat = false,
            i;
        ratio = parseFloat(ratio);

        if (reminder == 0) {
            return result;
        }

        if (ratio !== 0 && ratio != 1) {
            for (i = ratio, max = parseFloat(quantity) + parseFloat(ratio); i <= max; i = parseFloat(parseFloat(i) + parseFloat(ratio)).toFixed(4)) {
                result = i;
            }

        } else if (ratio === 1) {
            result = quantity | 0;
        }

        if (parseInt(result, 10) != parseFloat(result)) {
            bIsQuantityFloat = true;
        }

        result = (bUseFloatQuantity === false && bIsQuantityFloat === false) ? parseInt(result, 10) : parseFloat(result).toFixed(4);
        result = correctQuantity(result);
        return result;
    }

    window.correctQuantity = function (quantity) {
        return parseFloat((quantity * 1).toString());
    }

    // used when quantity is changed by clicking on arrows
    window.setQuantity = function (basketId, ratio, sign, bUseFloatQuantity) {

        var curVal = parseFloat(BX("QUANTITY_INPUT_" + basketId).value),
            newVal;

        newVal = (sign == 'up') ? curVal + ratio : curVal - ratio;

        if (newVal < 0)
            newVal = 0;

        if (bUseFloatQuantity) {
            newVal = parseFloat(newVal).toFixed(4);
        }
        newVal = correctQuantity(newVal);

        if (ratio > 0 && newVal < ratio) {
            // newVal = ratio;
        }

        if (!bUseFloatQuantity && newVal != newVal.toFixed(4)) {
            newVal = parseFloat(newVal).toFixed(4);
        }

        newVal = getCorrectRatioQuantity(newVal, ratio, bUseFloatQuantity);
        newVal = correctQuantity(newVal);


        BX("QUANTITY_INPUT_" + basketId).value = newVal;
        BX("QUANTITY_INPUT_" + basketId).defaultValue = newVal;

        updateQuantity('QUANTITY_INPUT_' + basketId, basketId, ratio, bUseFloatQuantity);
    }

    function updateRows() {
        var $dayContainer = $(document).find('#basket_items').find('.js-basket-day-container');

        window.updateAllDaysTotal();
        $dayContainer.each(function (keyDay, itemDay) {
            var $this = $(this),
                day = $this.data('day'),
                items = $this.find('.cook'),
                $totalContainer = $(document).find('.all__price[data-day="' + day + '"');

            var total_proteins = 0,
                total_fats = 0,
                total_carbohydrates = 0,
                total_caloricity = 0,
                total_price = 0,
                total_quantity = 0,
                total_base_price = 0;

            items.each(function (key, item) {
                var id = item.id;
                try {
                    var quantity = parseInt($(item).find('#QUANTITY_' + id).val()),
                        proteins = parseFloat($(item).find('#PROTEINS_' + id).text()),
                        fats = parseFloat($(item).find('#FATS_' + id).text()),
                        carbohydrates = parseFloat($(item).find('#CARBOHYDRATES_' + id).text()),
                        caloricity = parseFloat($(item).find('#CALORICITY_' + id).text()),
                        price = parseFloat($(item).find('#current_price_' + id).text()),
                        unrounded = parseFloat($(item).find('#unrounded_price_' + id).data('math-price')),
                        basePrice = parseFloat($(item).data('initial-price'));

                    total_proteins += (isNaN(proteins) ? 0 : proteins) * quantity;
                    total_fats += (isNaN(fats) ? 0 : fats) * quantity;
                    total_carbohydrates += (isNaN(carbohydrates) ? 0 : carbohydrates) * quantity;
                    total_caloricity += (isNaN(caloricity) ? 0 : caloricity) * quantity;
                    total_price += Math.round((isNaN(unrounded) ? 0 : unrounded) * quantity);
                    total_quantity += quantity;
                    total_base_price +=(isNaN(basePrice) ? 0 : basePrice) * quantity;

                } catch (e) {
                    console.log(e)
                }
            });

            $totalContainer.find('.js-total_proteins').text(total_proteins);
            $totalContainer.find('.js-total_fats').text(total_fats);
            $totalContainer.find('.js-total_carbohydrates').text(total_carbohydrates);
            $totalContainer.find('.js-total_caloricity').text(total_caloricity);
             $totalContainer.find('.js-total_price').html(formatPrice(total_price));
            $totalContainer.find('.js-total_quantity').text(total_quantity);
            $totalContainer.find('.js-total_price_old').html(formatPrice(total_base_price));
        });
    }

    function numberBaksetSpaces(x) {
        var parts = x.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        var result = parts.join(".") + formatCurrency();
        return result;
    }

    /**
     * @param basketItemId
     * @param {{BASKET_ID : string, BASKET_DATA : { GRID : { ROWS : {} }}, COLUMNS: {}, PARAMS: {}, DELETE_ORIGINAL : string }} res
     */
    function updateBasketTable(basketItemId, res) {
        var table = $(document).find('#basket_items').find('.cook'),
            rows,
            newBasketItemId,
            arItem,
            lastRow,
            newRow,
            arColumns,
            bShowDeleteColumn = false,
            bShowDelayColumn = false,
            bShowPropsColumn = false,
            bShowPriceType = false,
            bUseFloatQuantity,
            origBasketItem,
            oCellMargin,
            i,
            oCellName,
            imageURL,
            cellNameHTML,
            oCellItem,
            cellItemHTML,
            bSkip,
            j,
            val,
            propId,
            arProp,
            bIsImageProperty,
            countValues,
            full,
            fullWidth,
            itemWidth,
            arVal,
            valId,
            arSkuValue,
            selected,
            valueId,
            k,
            arItemProp,
            oCellQuantity,
            oCellQuantityHTML,
            ratio,
            isUpdateQuantity,
            oldQuantity,
            oCellPrice,
            fullPrice,
            id,
            oCellDiscount,
            oCellWeight,
            oCellCustom,
            customColumnVal,
            propsMap,
            selectedIndex,
            counter,
            marginLeft,
            createNewItem;

        if (!table || typeof res !== 'object') {
            return;
        }

        rows = table;
        lastRow = rows[rows.length - 1];
        bUseFloatQuantity = (res.PARAMS.QUANTITY_FLOAT === 'Y');

        // insert new row instead of original basket item row
        // if (basketItemId !== null && !!res.BASKET_DATA)

        // update product params after recalculation
        if (!!res.BASKET_DATA) {
            for (id in res.BASKET_DATA.GRID.ROWS) {
                if (res.BASKET_DATA.GRID.ROWS.hasOwnProperty(id)) {
                    var item = res.BASKET_DATA.GRID.ROWS[id];

                    if (BX('discount_value_' + id))
                        BX('discount_value_' + id).innerHTML = item.DISCOUNT_PRICE_PERCENT_FORMATED;

                    console.log('FROM BX',item.PRICE,(item.PRICE * item.QUANTITY));
                    //* ОКРУГЛЕНИЕ! */

                  if (BX('current_price_' + id)) {
                    BX('current_price_' + id).innerHTML = numberBaksetSpaces(Math.round(item.PRICE));
                    BX('unrounded_price_' + id).innerHTML = numberBaksetSpaces(item.PRICE);
                  }

                    if (BX('old_price_' + id))
                        BX('old_price_' + id).innerHTML = (item.DISCOUNT_PRICE_PERCENT > 0) ? item.FULL_PRICE_FORMATED : '';

                    if (BX('sum_' + id))
                        BX('sum_' + id).innerHTML = numberBaksetSpaces(item.SUM);

                    // if the quantity was set by user to 0 or was too much, we need to show corrected quantity value from ajax response
                    if (BX('QUANTITY_' + id)) {
                        BX('QUANTITY_INPUT_' + id).value = item.QUANTITY;
                        BX('QUANTITY_INPUT_' + id).defaultValue = item.QUANTITY;

                        BX('QUANTITY_' + id).value = item.QUANTITY;
                    }
                }
            }
        }

        // update coupon info
        if (!!res.BASKET_DATA)
            couponListUpdate(res.BASKET_DATA);

        // update warnings if any
        if (res.hasOwnProperty('WARNING_MESSAGE')) {
            var warningText = '';

            for (i = res['WARNING_MESSAGE'].length - 1; i >= 0; i--)
                warningText += res['WARNING_MESSAGE'][i] + '<br/>';

            BX('warning_message').innerHTML = warningText;
        }

        // update total basket values
        if (!!res.BASKET_DATA) {
            if (BX('allWeight_FORMATED'))
                BX('allWeight_FORMATED').innerHTML = res['BASKET_DATA']['allWeight_FORMATED'];

            if (BX('allSum_wVAT_FORMATED'))
                BX('allSum_wVAT_FORMATED').innerHTML = res['BASKET_DATA']['allSum_wVAT_FORMATED'];

            if (BX('allVATSum_FORMATED'))
                BX('allVATSum_FORMATED').innerHTML = res['BASKET_DATA']['allVATSum_FORMATED'];

            if (BX('allSum_FORMATED'))
                BX('allSum_FORMATED').innerHTML = res['BASKET_DATA']['allSum_FORMATED'];

            if (BX('allSum'))
                BX('allSum').innerHTML = numberBaksetSpaces(res['BASKET_DATA']['allSum']);


            var total_quantity;
            total_quantity = 0;

            res['BASKET_DATA']['ITEMS']['AnDelCanBuy'].forEach(function (item) {
                if (item['QUANTITY']) {
                    total_quantity += parseInt(item['QUANTITY']);
                }

                /*if (BX('total_quantity'))
                    BX('total_quantity').innerHTML = total_quantity;*/
            });

            updateRows();

            if (BX('PRICE_WITHOUT_DISCOUNT')) {
                var showPriceWithoutDiscount = (res['BASKET_DATA']['PRICE_WITHOUT_DISCOUNT'] != res['BASKET_DATA']['allSum_FORMATED']);
                BX('PRICE_WITHOUT_DISCOUNT').innerHTML = showPriceWithoutDiscount ? res['BASKET_DATA']['PRICE_WITHOUT_DISCOUNT'].replace(/\s/g, '&nbsp;') : '';
                BX.style(BX('PRICE_WITHOUT_DISCOUNT').parentNode, 'display', (showPriceWithoutDiscount ? 'table-row' : 'none'));
            }

            BX.onCustomEvent('OnBasketChange');
        }
    }

    /**
     * @param couponBlock
     * @param {COUPON: string, JS_STATUS: string} oneCoupon - new coupon.
     */
    function couponCreate(couponBlock, oneCoupon) {
        var couponClass = 'disabled';

        if (!BX.type.isElementNode(couponBlock))
            return;
        if (oneCoupon.JS_STATUS === 'BAD')
            couponClass = 'bad';
        else if (oneCoupon.JS_STATUS === 'APPLYED')
            couponClass = 'good';

        var coupon_html = '<div class="promocode-not-found__item"> <span class="promocode-not-found__item-title">'
            + oneCoupon.JS_CHECK_CODE + '</span> <div class="promocode-not-found__item-wrap"> <input class="promocode-not-found__item-value ' +
            couponClass + '" name="OLD_COUPON[]" disabled="disabled" readonly="" value="' +
            oneCoupon.COUPON + '"> <div class="promocode-not-found__item-delete" aria-label="удалить" data-coupon="' +
            oneCoupon.COUPON + '"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"> <g fill="none" fill-rule="evenodd"> <circle cx="12" cy="12" r="12" fill="#FFF"></circle> <g fill="#44474A" fill-rule="nonzero"> <path d="M7.985 9.051l7.193 7.193a.753.753 0 0 0 1.066-1.066L9.05 7.985a.753.753 0 0 0-1.066 1.066z"></path> <path d="M9.051 16.244l7.193-7.193a.753.753 0 0 0-1.066-1.066l-7.193 7.193a.753.753 0 0 0 1.066 1.066z"></path> </g> </g> </svg> </div> </div> </div>';

        $(couponBlock).append(coupon_html);
    }

    /**
     * @param {COUPON_LIST : []} res
     */
    function couponListUpdate(res) {
        var couponBlock,
            couponClass,
            fieldCoupon,
            couponsCollection,
            couponFound,
            i,
            j,
            key;

        if (!!res && typeof res !== 'object') {
            return;
        }

        couponBlock = BX('coupons_block');
        if (!!couponBlock) {
            if (!!res.COUPON_LIST && BX.type.isArray(res.COUPON_LIST)) {
                fieldCoupon = BX('coupon');
                if (!!fieldCoupon) {
                    fieldCoupon.value = '';
                }
                couponsCollection = BX.findChildren(couponBlock, {
                    tagName: 'input',
                    property: {name: 'OLD_COUPON[]'}
                }, true);

                if (!!couponsCollection) {
                    if (BX.type.isElementNode(couponsCollection)) {
                        couponsCollection = [couponsCollection];
                    }
                    for (i = 0; i < res.COUPON_LIST.length; i++) {
                        couponFound = false;
                        key = -1;
                        for (j = 0; j < couponsCollection.length; j++) {
                            if (couponsCollection[j].value === res.COUPON_LIST[i].COUPON) {
                                couponFound = true;
                                key = j;
                                couponsCollection[j].couponUpdate = true;
                                break;
                            }
                        }
                        if (couponFound) {
                            // couponClass = 'disabled';
                            // if (res.COUPON_LIST[i].JS_STATUS === 'BAD')
                            //     couponClass = 'bad';
                            // else if (res.COUPON_LIST[i].JS_STATUS === 'APPLYED')
                            //     couponClass = 'good';
                            //
                            // BX.adjust(couponsCollection[key], {props: {className: couponClass}});
                            // BX.adjust(couponsCollection[key].nextSibling, {props: {className: couponClass}});
                            // BX.adjust(couponsCollection[key].nextSibling.nextSibling, {html: res.COUPON_LIST[i].JS_CHECK_CODE});
                        } else {
                            couponCreate(BX('coupons_collection'), res.COUPON_LIST[i]);
                        }
                    }
                    for (j = 0; j < couponsCollection.length; j++) {
                        if (typeof (couponsCollection[j].couponUpdate) === 'undefined' || !couponsCollection[j].couponUpdate) {
                            BX.remove(couponsCollection[j].parentNode.parentNode);
                            couponsCollection[j] = null;
                        } else {
                            couponsCollection[j].couponUpdate = null;
                        }
                    }
                } else {
                    for (i = 0; i < res.COUPON_LIST.length; i++) {
                        couponCreate(couponBlock, res.COUPON_LIST[i]);
                    }
                }
            }
        }
        couponBlock = null;
    }

    function skuPropClickHandler() {
        var target = this,
            basketItemId,
            property,
            property_values = {},
            postData = {},
            action_var,
            all_sku_props,
            i,
            sku_prop_value,
            m;

        if (!!target && target.hasAttribute('data-value-id')) {
            BX.showWait();

            basketItemId = target.getAttribute('data-element');
            property = target.getAttribute('data-property');
            action_var = BX('action_var').value;

            property_values[property] = BX.util.htmlspecialcharsback(target.getAttribute('data-value-id'));

            // if already selected element is clicked
            if (BX.hasClass(target, 'bx_active')) {
                BX.closeWait();
                return;
            }

            // get other basket item props to get full unique set of props of the new product
            all_sku_props = BX.findChildren(BX(basketItemId), {tagName: 'ul', className: 'sku_prop_list'}, true);
            if (!!all_sku_props && all_sku_props.length > 0) {
                for (i = 0; all_sku_props.length > i; i++) {
                    if (all_sku_props[i].id !== 'prop_' + property + '_' + basketItemId) {
                        sku_prop_value = BX.findChildren(BX(all_sku_props[i].id), {
                            tagName: 'li',
                            className: 'bx_active'
                        }, true);
                        if (!!sku_prop_value && sku_prop_value.length > 0) {
                            for (m = 0; sku_prop_value.length > m; m++) {
                                if (sku_prop_value[m].hasAttribute('data-value-id')) {
                                    property_values[sku_prop_value[m].getAttribute('data-property')] = BX.util.htmlspecialcharsback(sku_prop_value[m].getAttribute('data-value-id'));
                                }
                            }
                        }
                    }
                }
            }

            postData = {
                'basketItemId': basketItemId,
                'sessid': BX.message('bitrix_sessid'),
                'site_id': BX.message('SITE_ID'),
                'props': property_values,
                'action_var': action_var,
                'select_props': BX('column_headers').value,
                'offers_props': BX('offers_props').value,
                'quantity_float': BX('quantity_float').value,
                'price_vat_show_value': BX('price_vat_show_value').value,
                'hide_coupon': BX('hide_coupon').value,
                'use_prepayment': BX('use_prepayment').value
            };

            postData[action_var] = 'select_item';

            BX.ajax({
                url: '/bitrix/components/bitrix/sale.basket.basket/ajax.php',
                method: 'POST',
                data: postData,
                dataType: 'json',
                onsuccess: function (result) {
                    BX.closeWait();
                    updateBasketTable(basketItemId, result);
                }
            });
        }
    }

    function getColumnName(result, columnCode) {
        if (BX('col_' + columnCode)) {
            return BX.util.trim(BX('col_' + columnCode).innerHTML);
        } else {
            return '';
        }
    }

    function leftScroll(prop, id, count) {
        count = parseInt(count, 10);
        var el = BX('prop_' + prop + '_' + id);

        if (el) {
            var curVal = parseInt(el.style.marginLeft, 10);
            if (curVal <= -20)
                el.style.marginLeft = curVal + 20 + '%';
        }
    }

    /*
    function startScrollbar() {
        var $block = $(".rid__main");
        if (window.screen.width > 640) {
            $block.mCustomScrollbar("destroy");
        } else {
            $block.mCustomScrollbar("destroy");
            $block.mCustomScrollbar({
                mouseWheel: {enable: true, preventDefault: false}
            });
        }
    }
    */

    function rightScroll(prop, id, count) {
        count = parseInt(count, 10);

        var el = BX('prop_' + prop + '_' + id);

        if (el) {
            var curVal = parseInt(el.style.marginLeft, 10);
            if (curVal > (5 - count) * 20)
                el.style.marginLeft = curVal - 20 + '%';
        }
    }

    function checkOut() {
        if (!!BX('coupon'))
            BX('coupon').disabled = true;
        BX("basket_form").submit();
        return true;
    }

    function updateBasket() {
        recalcBasketAjax({});
    }

    function enterCoupon() {
        var newCoupon = BX('coupon');
        if (!!newCoupon && !!newCoupon.value)
            recalcBasketAjax({'coupon': newCoupon.value});
    }

    function showBasketItemsList(val) {
        BX.removeClass(BX("basket_toolbar_button"), "current");
        BX.removeClass(BX("basket_toolbar_button_delayed"), "current");
        BX.removeClass(BX("basket_toolbar_button_subscribed"), "current");
        BX.removeClass(BX("basket_toolbar_button_not_available"), "current");

        BX("normal_count").style.display = 'inline-block';
        BX("delay_count").style.display = 'inline-block';
        BX("subscribe_count").style.display = 'inline-block';
        BX("not_available_count").style.display = 'inline-block';

        if (val == 2) {
            if (BX("basket_items_list"))
                BX("basket_items_list").style.display = 'none';
            if (BX("basket_items_delayed")) {
                BX("basket_items_delayed").style.display = 'block';
                BX.addClass(BX("basket_toolbar_button_delayed"), "current");
                BX("delay_count").style.display = 'none';
            }
            if (BX("basket_items_subscribed"))
                BX("basket_items_subscribed").style.display = 'none';
            if (BX("basket_items_not_available"))
                BX("basket_items_not_available").style.display = 'none';
        } else if (val == 3) {
            if (BX("basket_items_list"))
                BX("basket_items_list").style.display = 'none';
            if (BX("basket_items_delayed"))
                BX("basket_items_delayed").style.display = 'none';
            if (BX("basket_items_subscribed")) {
                BX("basket_items_subscribed").style.display = 'block';
                BX.addClass(BX("basket_toolbar_button_subscribed"), "current");
                BX("subscribe_count").style.display = 'none';
            }
            if (BX("basket_items_not_available"))
                BX("basket_items_not_available").style.display = 'none';
        } else if (val == 4) {
            if (BX("basket_items_list"))
                BX("basket_items_list").style.display = 'none';
            if (BX("basket_items_delayed"))
                BX("basket_items_delayed").style.display = 'none';
            if (BX("basket_items_subscribed"))
                BX("basket_items_subscribed").style.display = 'none';
            if (BX("basket_items_not_available")) {
                BX("basket_items_not_available").style.display = 'block';
                BX.addClass(BX("basket_toolbar_button_not_available"), "current");
                BX("not_available_count").style.display = 'none';
            }
        } else {
            if (BX("basket_items_list")) {
                BX("basket_items_list").style.display = 'block';
                BX.addClass(BX("basket_toolbar_button"), "current");
                BX("normal_count").style.display = 'none';
            }
            if (BX("basket_items_delayed"))
                BX("basket_items_delayed").style.display = 'none';
            if (BX("basket_items_subscribed"))
                BX("basket_items_subscribed").style.display = 'none';
            if (BX("basket_items_not_available"))
                BX("basket_items_not_available").style.display = 'none';
        }
    }

    function deleteCoupon() {
        var target = this,
            value;

        if (BX.type.isElementNode(target) && target.hasAttribute('data-coupon')) {
            value = target.getAttribute('data-coupon');
            if (BX.type.isNotEmptyString(value)) {
                recalcBasketAjax({'delete_coupon': value});
            }
        }
    }

    function deleteProductRow(target) {
        // console.log(target);
        var targetRow = $(target).parents().find('.cook'),
            quantityNode,
            delItem;

        if (targetRow) {
            quantityNode = BX('QUANTITY_' + targetRow.id);
            if (quantityNode) {
                delItem = getCurrentItemAnalyticsInfo(targetRow, quantityNode.value);
            }
        }

        document.location.href = $(target).data('href');

        return false;
    }

    function checkAnalytics(currentQuantity, newItems) {
        if (!currentQuantity || !newItems || BX.util.array_values(currentQuantity).length === 0)
            return;

        var itemId, diff,
            current = {}, addItems = [], delItems = [],
            i;

        if (!!newItems && newItems.rows.length) {
            for (i = 1; newItems.rows.length > i; i++) {
                itemId = newItems.rows[i].id;
                diff = BX('QUANTITY_' + itemId).value - currentQuantity[itemId];

                if (diff != 0) {
                    current = getCurrentItemAnalyticsInfo(newItems.rows[i], diff);

                    if (diff > 0) {
                        addItems.push(current);
                    } else {
                        delItems.push(current);
                    }
                }
            }
        }

        if (addItems.length || delItems.length) {
            setAnalyticsDataLayer(addItems, delItems);
        }
    }

    function getCurrentItemAnalyticsInfo(row, diff) {
        if (!row)
            return;

        var temp, k, variants = [];

        var current = {
            'name': row.getAttribute('data-item-name') || '',
            'id': row.id,
            'price': row.getAttribute('data-item-price') || 0,
            'brand': (row.getAttribute('data-item-brand') || '').split(',  ').join('/'),
            'variant': '',
            'quantity': Math.abs(diff)
        };

        temp = row.querySelectorAll('.bx_active[data-sku-name]');
        for (k = 0; k < temp.length; k++) {
            variants.push(temp[k].getAttribute('data-sku-name'));
        }

        current.variant = variants.join('/');

        return current;
    }

    function setAnalyticsDataLayer(addItems, delItems) {
        window[basketJSParams['DATA_LAYER_NAME']] = window[basketJSParams['DATA_LAYER_NAME']] || [];

        if (addItems && addItems.length) {
            window[basketJSParams['DATA_LAYER_NAME']].push({
                'event': 'addToCart',
                'ecommerce': {
                    'currencyCode': getCurrencyCode(),
                    'add': {
                        'products': addItems
                    }
                }
            });
        }

        if (delItems && delItems.length) {
            window[basketJSParams['DATA_LAYER_NAME']].push({
                'event': 'removeFromCart',
                'ecommerce': {
                    'currencyCode': getCurrencyCode(),
                    'remove': {
                        'products': delItems
                    }
                }
            });
        }
    }

    function getCurrencyCode() {
        var root = BX('basket_items'),
            node,
            currency = '';

        if (root) {
            node = root.querySelector('[data-item-currency');
            node && (currency = node.getAttribute('data-item-currency'));
        }

        return currency;


    }

    window.initMonthSlider = function () {
        var $slider = $(document).find(".month");
        $slider.removeClass('hide');

        $slider.slick({
            infinite: true,
            dots: false,
            arrows: false,
            slidesToScroll: 7,
            autoplay: false,
            autoplaySpeed: 5000,
            autoplayHoverPause: true,
            fade: false,
            touchThreshold: 14,
            swipeToSlide: true,
            slidesToShow: 7,
            responsive: [{breakpoint: 640, settings: {slidesToScroll: 5, slidesToShow: 5}}]
        });

        $slider.removeClass("loading");
        $(".menu-nav_mob").removeClass("loading");
    }

    $(function () {

        var cardsScroll;

        reloadBasket();

        window.basketPoolQuantity = new BasketPoolQuantity();
        var couponBlock = BX('coupons_block'),
            basketItems = BX('basket_items');

        if (BX.type.isElementNode(couponBlock))
            BX.bindDelegate(couponBlock, 'click', {'attribute': 'data-coupon'}, deleteCoupon);

        if (BX.type.isElementNode(basketItems))
            BX.bindDelegate(basketItems, 'click', {
                tagName: 'li',
                'attr': {'data-sku-selector': 'Y'}
            }, skuPropClickHandler);

        $(document).on('click', '.remove', function () {
            var productId = $(this).closest('.cook').attr('data-product');
            $.ajax({
                method: 'POST',
                url: '/ajax/basketItem.php',
                data: {action: 'delete', id: productId},
                dataType: 'json',
                success: function (result) {

                    if (result.success) {

                        var dayId = $(document).find('.js-basket-menu-day.day_active').data('id');

                        $.ajax({
                            url: '/personal/cart/',
                            success: function (res) {
                                $(document).find('.full_basket').html($(res).find('.full_basket').html());
                                initMonthSlider();
                                $(document).find('.js-basket-menu-day[data-id="' + dayId + '"]').trigger('click');
                            }
                        });

                        $.ajax({
                            url: '/',
                            success: function (result) {
                                $(document).find('.modalCards').html($(result).find('.modalCards').html())
                            }
                        });

                    }
                }
            })
        });

        /*window.addEventListener("load", function () {
            startScrollbar();
        });*/
    })
})(jQuery)
